module.exports = __webpack_public_path__ + "static/media/cert_94.a89371a2.jpg";